import React, { useState, useRef, useMemo, useEffect } from 'react';
import './Navix.css';
import AuthDialog from '../AuthDialog';
import { useApi } from '../../context/apiContext';
import usePopup from '../../hooks/usePopup';
import Popup from '../PopUp';

// Import new components and hooks
import MapContainer from './components/MapContainer';
import useMapControls from './hooks/useMapControls';
import useLayerData from './hooks/useLayerData';
import LayerPanel from './components/LayerPanel';
import { trackEvent, NAVIX_SEARCH } from '../../utils/googleAnalytics';

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_KEY;

const Navix = ({ isAuthenticated, token }) => {
    // console.log('Navix - Token:', token);
    const memoizedHeaders = useMemo(() => {
        return token ? { Authorization: `Bearer ${token}` } : {};
      }, [token]);

    // console.log('Navix - Headers:', headers);
    const { apiType, apiClient } = useApi();
    // console.log('Navix - API Type:', apiType);
    const mapRef = useRef(null);

    const [showAuthDialog, setShowAuthDialog] = useState(false);

    // Add the usePopup hook
    const {
        isPopupOpen,
        popupDetails,
        handleOpenPopup,
        handleClosePopup,
        popupLoading,
        spatialExtent,
    } = usePopup(memoizedHeaders);

    // Use the layer data hook
    const {
        selectedLayer,
        layerModels,
        loadingModels,
        hasMoreModels,
        isPanelVisible,
        setIsPanelVisible,
        fetchLayerData,
        loadMoreLayerModels
    } = useLayerData({
        apiClient,
        apiType,
        headers: memoizedHeaders,
        mapRef,
        isAuthenticated,
        setShowAuthDialog
    });



    // Use the map controls hook
    const {
        isLayerLoading,
        loadingLayerName,
        handleMapLoad,
        toggleLayer,
        fitMapToBounds
    } = useMapControls({
        mapRef,
        fetchLayerData,
    });

    useEffect(() => {
      if (selectedLayer) {
        trackEvent(NAVIX_SEARCH, 'Navix Search Page', { layer_name: selectedLayer.name || selectedLayer.id });
      }
    }, [selectedLayer]);

    return (
        <div className="county-container">
            {/* Map Section - Using the MapContainer component */}
            <MapContainer
                mapRef={mapRef}
                mapboxToken={MAPBOX_TOKEN}
                handleMapLoad={handleMapLoad}
                toggleLayer={toggleLayer}
                isLayerLoading={isLayerLoading}
                loadingLayerName={loadingLayerName}
                fitMapToBounds={fitMapToBounds}
                isAuthenticated={isAuthenticated}
                setShowAuthDialog={setShowAuthDialog}
            >
                {/* Add county models panel inside the map container */}
                {isPanelVisible && selectedLayer && (
                    <LayerPanel
                        selectedLayer={selectedLayer}
                        layerModels={layerModels}
                        loadingModels={loadingModels}
                        hasMoreModels={hasMoreModels}
                        loadMoreLayerModels={loadMoreLayerModels}
                        handleOpenPopup={handleOpenPopup}
                        setIsPanelVisible={setIsPanelVisible}
                    />
                )}

                {/* Add region models panel inside the map container */}
                {/* {regionPanelVisible && selectedRegion && (
                    <RegionPanel
                        selectedRegion={selectedRegion}
                        regionModels={regionModels}
                        loadingModels={loadingModels}
                        hasMoreModels={hasMoreModels}
                        loadMoreModels={loadMoreModels}
                        handleOpenPopup={handleOpenPopup}
                        setIsPanelVisible={setRegionPanelVisible}
                    />
                )} */}
            </MapContainer>

            <AuthDialog
                isOpen={showAuthDialog}
                onClose={() => setShowAuthDialog(false)}
            />

            {/* Add the Popup component */}
            {popupLoading && (
                <div className="loading-indicator">
                    <p>Loading preview data</p>
                    <div className="dots">
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                    </div>
                </div>
            )}
            {!popupLoading && isPopupOpen && (
                <Popup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    details={popupDetails}
                    headers={memoizedHeaders}
                    spatialExtent={spatialExtent}
                />
            )}


        </div>
    );
};

export default Navix;